import React, { useState } from "react";
import { motion } from "framer-motion";
import { Play, Youtube } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import SectionTitle from "./SectionTitle";
import { CLIPS, STREAMING } from "../data/content";

export const Clips = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="clips" className="section bg-[#050505] py-28">
      <div className="orb orb-purple" style={{ width: 420, height: 420, bottom: "0%", left: "-8%" }} />
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionTitle kicker="Vidéos" title="Les clips" testid="clips-title" />
          <a
            data-testid="youtube-channel-btn"
            href={STREAMING.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-glow mb-12 flex items-center gap-2 rounded-full bg-[#FF0000]/90 px-6 py-3 font-heading text-sm font-semibold text-white"
          >
            <Youtube size={20} /> Voir la chaîne
          </a>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {CLIPS.map((clip, i) => (
            <motion.button
              key={clip.id}
              data-testid={`clip-card-${i}`}
              onClick={() => setActive(clip)}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.12 }}
              className="group relative aspect-video overflow-hidden rounded-2xl text-left"
            >
              <img
                src={`https://img.youtube.com/vi/${clip.id}/hqdefault.jpg`}
                alt={clip.title}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/10 backdrop-blur-md transition-all duration-300 group-hover:scale-110 group-hover:bg-electric">
                  <Play size={26} fill="currentColor" className="ml-1 text-white" />
                </span>
              </div>
              <div className="absolute bottom-0 left-0 p-5">
                <h3 className="font-heading text-base font-semibold text-white">{clip.title}</h3>
                <p className="font-body text-xs text-white/60">Oli.Vero — YouTube</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl border-white/10 bg-black p-2" data-testid="clip-lightbox">
          <DialogTitle className="sr-only">{active?.title || "Clip Oli.Vero"}</DialogTitle>
          <DialogDescription className="sr-only">Lecture du clip vidéo {active?.title} d'Oli.Vero</DialogDescription>
          {active && (
            <div className="aspect-video w-full overflow-hidden rounded-lg">
              <iframe
                title={active.title}
                src={`https://www.youtube.com/embed/${active.id}?autoplay=1&rel=0`}
                className="h-full w-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Clips;
